import { mediaItems } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Colorful%20anime%20manga%20themed%20banner%20illustration%20with%20vibrant%20warm%20orange%20and%20coral%20colors%2C%20dynamic%20composition%20with%20comic%20panel%20layout%2C%20speech%20bubbles%20and%20action%20speed%20lines%2C%20clean%20Japanese%20manga%20aesthetic%2C%20soft%20warm%20gradient%20background%20with%20gentle%20light&width=800&height=450&seq=media-thumb-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Warm%20toned%20anime%20style%20editorial%20illustration%20featuring%20comic%20book%20elements%2C%20decorative%20manga%20panels%20and%20halftone%20patterns%2C%20energetic%20composition%20with%20bold%20graphic%20shapes%2C%20clean%20white%20and%20cream%20background%20with%20subtle%20texture%2C%20modern%20pop%20art%20inspired%20design&width=800&height=450&seq=media-thumb-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20manga%20inspired%20visual%20with%20abstract%20comic%20elements%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20dynamic%20diagonal%20composition%20with%20overlapping%20panels%2C%20soft%20gradient%20background%20with%20dot%20screen%20texture%2C%20contemporary%20graphic%20design%20aesthetic&width=800&height=450&seq=media-thumb-3&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精彩推荐</h2>
            <p className="mt-1 text-sm text-foreground-500">编辑精选 · 新番导视 · 深度观察</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className="relative h-44 md:h-48 bg-gradient-to-br from-primary-100/60 to-accent-100/50 overflow-hidden">
                <img
                  src={mediaImages[item.id - 1]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[11px] px-2.5 py-1 rounded-full bg-background-50/90 text-primary-700 font-medium backdrop-blur-sm">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                  <span><i className="ri-user-line mr-1"></i>{item.author}</span>
                  <span>{item.time}</span>
                  <span className="ml-auto"><i className="ri-eye-line mr-1"></i>{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}